'use client';

import { LocalizedLink } from '@/components/LocalizedLink';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body className="bg-space antialiased text-slate-100">
        <header className="sticky top-0 z-50 border-b border-white/10 bg-[#0b0d19]/80 backdrop-blur">
          <div className="mx-auto flex w-full max-w-6xl items-center justify-between gap-6 px-6 py-4">
            <LocalizedLink href="/" className="text-xl font-bold text-white">
              Hotlist<span className="text-[#ffb74d]">Casino</span>
            </LocalizedLink>
          </div>
        </header>

        <main className="px-6 py-16">
          <div className="mx-auto w-full max-w-5xl">
            <div className="rounded-2xl border border-white/10 bg-white/5 p-8">
              <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-[#15192b] px-3 py-1 text-xs text-slate-300">
                Error
                {error?.digest ? (
                  <span className="text-slate-500">• Digest: {error.digest}</span>
                ) : null}
              </div>
              <h1 className="mt-4 text-3xl font-semibold text-white">Something went wrong</h1>
              <p className="mt-2 max-w-2xl text-sm text-slate-400">
                A critical error occurred while rendering the application shell.
              </p>

              <div className="mt-6 flex flex-wrap gap-3">
                <button
                  type="button"
                  onClick={reset}
                  className="rounded-full bg-[#ffb74d] px-4 py-2 text-xs font-semibold text-[#4a2800]"
                >
                  Try again
                </button>
                <LocalizedLink
                  href="/"
                  className="rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs font-semibold text-slate-200 hover:bg-white/10"
                >
                  Go to home
                </LocalizedLink>
              </div>
            </div>
          </div>
        </main>

        <footer className="border-t border-white/10 bg-[#0b0d19]/80">
          <div className="mx-auto flex w-full max-w-6xl flex-col gap-3 px-6 py-6 text-sm text-slate-400 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p className="font-semibold text-white">Hotlist Casino</p>
              <p>Casino rankings, reviews, and responsible gaming guidance.</p>
            </div>
            <div className="flex gap-4">
              <LocalizedLink className="hover:text-white" href="/game-providers">
                Game Providers
              </LocalizedLink>
              <LocalizedLink className="hover:text-white" href="/terms">
                Terms &amp; Conditions
              </LocalizedLink>
              <LocalizedLink className="hover:text-white" href="/privacy-policy">
                Privacy Policy
              </LocalizedLink>
              <LocalizedLink className="hover:text-white" href="/contact">
                Contact
              </LocalizedLink>
            </div>
          </div>
        </footer>
      </body>
    </html>
  );
}

